import logo from "./logo.svg";
import { useState } from "react";
import "./App.css";
import Admin from "./Pages/Admin";
import ServiceInfo from "./Components/ServiceInfo";
import {
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
  Routes,
  Route,
  Link,
  Outlet,
  Navigate,
} from "react-router-dom";
import AdminServices from "./Pages/AdminServices";
import AdminTeamAdminstration from "./Pages/AdminTeamAdminstration";
import AdminLob from "./Pages/AdminLob";
import AdminFormsAndFields from "./Pages/AdminFormsAndFields";
import FormInfo from "./Components/FormInfo";
import FormSection from "./Components/Section/FormSection";
import FieldSection from "./Components/FieldSection/FieldSection";
import AgentHomePage from "./Pages/Agent/AgentHomePage";
import AgentFormsAndServices from "./Pages/Agent/AgentFormsAndServices";
import OfflineForm from "./Components/Agent/FormsView";
import InboundVDNs from "./Pages/InboundVDNs";
import OutboundVDNs from "./Pages/OutboundVDNs";
import AdminTenantIdle from "./Pages/AdminTenantIdle";
import AdminUserToTeam from "./Pages/AdminUserToTeam";
import AdminEditRecords from "./Pages/AdminEditRecords";
import AdminPhonebook from "./Pages/AdminPhonebook";
import PreviewForm from "./Pages/PreviewForm";
import AdminIntradayView from "./Pages/AdminIntradayView";
import AdminSettings from "./Pages/AdminSettings";
import AdminLiveView from "./Pages/AdminLiveView";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import AdminUserRoles from "./Pages/AdminUserRoles";
import AdminUnauthorized from "./Pages/AdminUnauthorized";
import { LanguageProvider } from "./Components/Localization/LanguageContext";
import PostLogoutPage from "./Pages/PostLogout";
import ErrorBoundary from "./Components/ErrorBoundary";
import AdminTenantManagement from "./Pages/AdminTenantManagement";
import AdminMasterIdles from "./Pages/AdminMasterIdles";
import { UserCacheProvider } from "./Components/UserCacheProvider";
import AdminHouseManagement from "./Pages/AdminHouseManagement";
import AdminHousePage from "./Pages/AdminHousePage";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route
        path="/postLogout"
        element={
          <UnauthenticatedTemplate>
            <PostLogoutPage></PostLogoutPage>
          </UnauthenticatedTemplate>
        }
      ></Route>
      <Route
        path="/"
        element={
          <AuthenticatedTemplate>
            <ErrorBoundary>
              <Admin />
            </ErrorBoundary>
          </AuthenticatedTemplate>
        }
      >
        <Route path="/services" element={<AdminServices />}>
          <Route path=":id" element={<ServiceInfo />} />
        </Route>

        <Route path="/editrecords" element={<AdminEditRecords />} />
        <Route path="/formsandfields" element={<AdminFormsAndFields />}>
          <Route path=":id" element={<FormInfo />}></Route>
          <Route path="createform" element={<FormInfo />} />
          <Route path=":id/addSection" element={<FormSection />} />
          <Route path=":id/section/:sectionId" element={<FormSection />} />
          <Route
            path=":id/section/:sectionId/field/:fieldId"
            element={<FieldSection />}
          />
          <Route
            path=":id/section/:sectionId/addField"
            element={<FieldSection />}
          />
        </Route>
      </Route>
      <Route path="/previewForm/:id" element={<PreviewForm />} />
      <Route path="/teams" element={<Admin />}>
        <Route index element={<AdminTeamAdminstration />} />
      </Route>

      <Route path="/lobs" element={<Admin />}>
        <Route index element={<AdminLob />} />
      </Route>

      <Route path="/phonebook" element={<Admin />}>
        <Route index element={<AdminPhonebook />} />
      </Route>

      <Route
        path="/agent"
        element={
          <AuthenticatedTemplate>
            <ErrorBoundary>
              <AgentHomePage />
            </ErrorBoundary>
          </AuthenticatedTemplate>
        }
      >
        <Route index element={<AgentFormsAndServices />} />
        {/* <Route path="/agent/form" element={<AgentFormsAndServices />}>
          <Route path=":id" element={<OfflineForm />} />
        </Route> */}
      </Route>
      {/* <Route path="/choosetenant" element={<ChooseTenant />} /> */}

      <Route path="/inboundvdns" element={<Admin />}>
        <Route index element={<InboundVDNs />} />
      </Route>

      <Route path="/outboundlines" element={<Admin />}>
        <Route index element={<OutboundVDNs />} />
      </Route>

      <Route path="/tenantidles" element={<Admin />}>
        <Route index element={<AdminTenantIdle />} />
      </Route>

      <Route path="/usertoteam" element={<Admin />}>
        <Route index element={<AdminUserToTeam />} />
      </Route>
      <Route path="/intradayview" element={<Admin />}>
        <Route index element={<AdminIntradayView />} />
      </Route>
      <Route path="/liveview" element={<Admin />}>
        <Route index element={<AdminLiveView />} />
      </Route>
      <Route path="/managetenants" element={<Admin />}>
        <Route index element={<AdminTenantManagement />} />
      </Route>
      <Route path="/userroles" element={<Admin />}>
        <Route index element={<AdminUserRoles />} />
      </Route>
      <Route path="/unauthorized" element={<Admin />}>
        <Route index element={<AdminUnauthorized />} />
      </Route>
      <Route path="/settings" element={<Admin />}>
        <Route index element={<AdminSettings />} />
      </Route>
      <Route path="/masteridles" element={<Admin />}>
        <Route index element={<AdminMasterIdles />} />
      </Route>
      <Route path="/housemanagement" element={<Admin />}>
        <Route index element={<AdminHouseManagement />} />
      </Route>
      <Route path="/house/:id" element={<Admin />}>
        <Route index element={<AdminHousePage />} />
      </Route>
      <Route path="/agent/house/did/:id">
        <Route index element={<AdminHousePage />} />
      </Route>
      <Route path="/agent/house/byId/:id">
        <Route index element={<AdminHousePage />} />
      </Route>
      <Route path="/agent/unauthorized" element={<AdminUnauthorized />}></Route>
      <Route path="/unauthorizedMsal" element={<AdminUnauthorized />}></Route>
      <Route
        path="/agent/unauthorizedMsal"
        element={<AdminUnauthorized />}
      ></Route>
      <Route
        path="/errorBoundary"
        element={<ErrorBoundary hasError={true} />}
      ></Route>

      <Route
        path="not-found"
        element={
          <ErrorBoundary
            hasError={true}
            customError={`Page Not Found. Reload the page.`}
          />
        }
      />

      <Route
        path="*"
        element={
          <ErrorBoundary
            hasError={true}
            customError={`Page Not Found. Reload the page.`}
          />
        }
      />
    </>
  )
);

function App() {
  return (
    <LanguageProvider>
      <UserCacheProvider>
        <RouterProvider router={router} />
      </UserCacheProvider>
    </LanguageProvider>
  );
}

export default App;
